/* Tegriware site sections: product page, filters, FAQ search, forms, estimator, engraving preview. No dependencies. */
(function () {
  if (window.__twsInit) return;
  window.__twsInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(cents, fmt) {
    fmt = fmt || (window.theme && theme.settings && theme.settings.money_format) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var a = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, a.split('.')[0]).replace(/\{\{\s*amount\s*\}\}/, a).replace(/<[^>]+>/g, '');
  }

  /* ---------- Product page ---------- */
  function initPdp(root) {
    if (root.__tws) return; root.__tws = true;
    var dataEl = $('[data-tws-product]', root);
    var data = {}; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('form[data-tws-form]', root);
    var idInput = form && $('input[name="id"]', form);
    var main = $('[data-tws-main]', root);
    var thumbs = $$('[data-tws-thumb]', root);
    var idx = 0;
    function show(i) {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      var img = main && main.querySelector('img');
      if (img) { img.src = t.getAttribute('data-src'); img.removeAttribute('srcset'); img.alt = t.getAttribute('data-alt') || ''; }
      thumbs.forEach(function (b, n) { b.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
      var c = $('[data-tws-frame]', root); if (c) c.textContent = (idx + 1) + ' of ' + thumbs.length;
    }
    thumbs.forEach(function (b, n) { b.addEventListener('click', function () { show(n); }); });
    $$('[data-tws-prev]', root).forEach(function (b) { b.addEventListener('click', function () { show(idx - 1); }); });
    $$('[data-tws-next]', root).forEach(function (b) { b.addEventListener('click', function () { show(idx + 1); }); });

    function selected() { return $$('[data-tws-option]', root).map(function (g) { var c = $('input:checked', g); return c ? c.value : g.getAttribute('data-fixed'); }); }
    function update() {
      var sel = selected(); var v = null;
      (data.variants || []).forEach(function (x) { if (!v && x.options.every(function (o, i) { return sel[i] == null || o === sel[i]; })) v = x; });
      $$('[data-tws-option]', root).forEach(function (g) { var c = $('input:checked', g); var l = $('[data-tws-chosen]', g); if (c && l) l.textContent = c.value; });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      $$('[data-tws-price]', root).forEach(function (e) { e.textContent = money(v.price); });
      $$('[data-tws-compare]', root).forEach(function (e) { e.textContent = v.compare > v.price ? money(v.compare) : ''; e.hidden = !(v.compare > v.price); });
      $$('[data-tws-atc]', root).forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? b.getAttribute('data-label') : b.getAttribute('data-sold'); });
      if (v.media != null) { var n = thumbs.findIndex(function (t) { return +t.getAttribute('data-id') === v.media; }); if (n > -1) show(n); }
      if (window.history && history.replaceState && data.url) { try { history.replaceState(null, '', data.url + '?variant=' + v.id); } catch (e) {} }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-tws-option]')) update(); });
    $$('[data-tws-qty]', root).forEach(function (q) {
      var input = $('input', q);
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var n = (parseInt(input.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1);
        input.value = Math.max(1, n);
      });
    });
    var sticky = $('[data-tws-sticky]', root), atc = $('[data-tws-atc]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.inert = !on; }).observe(atc);
      var sb = $('button', sticky); if (sb) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  }

  /* ---------- Filters: product grid, blog, FAQ ---------- */
  function initFilter(root) {
    if (root.__tws) return; root.__tws = true;
    var chips = $$('[data-tws-chip]', root);
    var items = $$('[data-tws-item]', root);
    var search = $('[data-tws-search]', root);
    var countEl = $('[data-tws-count]', root);
    var empty = $('[data-tws-empty]', root);
    var sort = $('[data-tws-sort]', root);
    var list = $('[data-tws-list]', root);
    var cur = 'all';
    function apply() {
      var q = search ? search.value.trim().toLowerCase() : '';
      var n = 0;
      items.forEach(function (it) {
        var keys = (' ' + (it.getAttribute('data-keys') || '') + ' ');
        var okCat = cur === 'all' || keys.indexOf(' ' + cur + ' ') > -1;
        var okQ = !q || it.textContent.toLowerCase().indexOf(q) > -1;
        it.hidden = !(okCat && okQ); if (!it.hidden) n++;
      });
      if (countEl) countEl.textContent = n + ' ' + (countEl.getAttribute('data-noun') || 'items');
      if (empty) empty.hidden = n > 0;
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { cur = c.getAttribute('data-tws-chip'); chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); }); apply(); }); });
    if (search) search.addEventListener('input', apply);
    if (sort && list) sort.addEventListener('change', function () {
      var v = sort.value;
      items.slice().sort(function (a, b) {
        if (v === 'asc') return +a.getAttribute('data-price') - +b.getAttribute('data-price');
        if (v === 'desc') return +b.getAttribute('data-price') - +a.getAttribute('data-price');
        return +a.getAttribute('data-i') - +b.getAttribute('data-i');
      }).forEach(function (it) { list.appendChild(it); });
    });
    apply();
  }

  /* ---------- Forms with topics ---------- */
  function initForm(root) {
    if (root.__tws) return; root.__tws = true;
    var chips = $$('[data-tws-topic]', root);
    var hidden = $('[data-tws-topic-input]', root);
    var help = $('[data-tws-topic-help]', root);
    var msg = $('[data-tws-message]', root);
    function pick(c) {
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      var t = c.getAttribute('data-tws-topic');
      if (hidden) hidden.value = c.getAttribute('data-label');
      if (help) help.textContent = c.getAttribute('data-help') || '';
      if (msg && c.getAttribute('data-placeholder')) msg.placeholder = c.getAttribute('data-placeholder');
      $$('[data-show-for]', root).forEach(function (f) {
        var list = (f.getAttribute('data-show-for') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var on = !list.length || list.indexOf(t) > -1;
        f.hidden = !on; $$('input,select,textarea', f).forEach(function (i) { i.disabled = !on; });
      });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });
    var pre = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || chips[0];
    var hash = (location.hash || '').replace('#', '');
    chips.forEach(function (c) { if (c.getAttribute('data-tws-topic') === hash) pre = c; });
    if (pre) pick(pre);
  }

  function isEarly(d) { if (!d) return true; var t = Date.parse(d); return isNaN(t) || Date.now() < t; }
  function short(c) { return money(c).replace(/\.00$/, ''); }

  /* ---------- Volume estimator ---------- */
  function initEstimator(root) {
    if (root.__tws) return; root.__tws = true;
    var qty = $('[data-tws-est-qty]', root);
    var min = +qty.getAttribute('min') || 1;
    var early = isEarly(root.getAttribute('data-deadline'));
    var fee = +root.getAttribute('data-eng-fee') || 0;
    var A = function (n) { return root.getAttribute('data-' + n) || ''; };
    function unitOf(inp) { return early ? +inp.getAttribute('data-unit') : +(inp.getAttribute('data-after') || inp.getAttribute('data-unit')); }
    $$('input[name="tws-est-set"]', root).forEach(function (inp) {
      var u = unitOf(inp), reg = +inp.getAttribute('data-regular'), l = inp.parentNode.querySelector('[data-tws-est-label]');
      if (l) l.textContent = short(u) + '/ea' + (reg > u ? ' · was ' + short(reg) : '');
    });
    function sel(name) { return $('input[name="' + name + '"]:checked', root); }
    function calc() {
      var s = sel('tws-est-set'); if (!s) return;
      var q = Math.max(min, parseInt(qty.value, 10) || min); qty.value = q;
      var wood = s.getAttribute('data-wood') === '1';
      var unit = unitOf(s) + (wood && !early ? fee : 0), reg = +s.getAttribute('data-regular');
      var engNote = wood ? (early ? s.getAttribute('data-eng') || A('incl-early') : (fee ? A('incl-late') : '')) : (s.getAttribute('data-eng') || '');
      var box = $('[data-tws-est-engbox]', root);
      if (box) { box.hidden = !wood; $$('input', box).forEach(function (i) { i.disabled = !wood; }); }
      var note = $('[data-tws-est-note]', root);
      if (note) note.textContent = !wood ? A('note-none') : (early ? A('note-early') : (A('note-late') || A('note-early')));
      var eng = wood ? sel('tws-est-eng') : null;
      var total = unit * q, save = (reg - unit) * q;
      $('[data-tws-est-line]', root).textContent = q + ' × ' + s.getAttribute('data-name') + ' sets';
      $('[data-tws-est-total]', root).textContent = short(total);
      $('[data-tws-est-unit]', root).textContent = short(unit) + ' per set' + (engNote ? ' · ' + engNote : '');
      var sv = $('[data-tws-est-save]', root); sv.hidden = !(save > 0); sv.textContent = 'You save ' + short(save) + ' vs. regular price';
      var summary = q + ' ' + s.getAttribute('data-name') + ' sets' + (eng ? ', engraving: ' + eng.value : '') + ' · est. ' + short(total);
      $$('[data-tws-estimate-target]').forEach(function (t) { if (t.tagName === 'INPUT') t.value = summary; else { t.textContent = 'Your estimate: ' + summary; t.hidden = false; } });
    }
    root.addEventListener('change', calc);
    qty.addEventListener('input', calc);
    $$('[data-tws-step]', root).forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(min, (parseInt(qty.value, 10) || min) + +b.getAttribute('data-tws-step')); calc(); }); });
    calc();
  }

  /* ---------- Offer countdown and end-of-offer prices ---------- */
  function initCountdown(el) {
    if (el.__tws) return; el.__tws = true;
    var t = Date.parse(el.getAttribute('data-deadline'));
    if (isNaN(t)) return;
    var days = Math.ceil((t - Date.now()) / 86400000);
    if (days > 0) el.textContent = el.getAttribute('data-text').replace('[days]', days + (days === 1 ? ' day' : ' days'));
    else el.textContent = el.getAttribute('data-ended') || '';
  }
  function initOffers(root) {
    if (root.__tws) return; root.__tws = true;
    if (isEarly(root.getAttribute('data-deadline'))) return;
    $$('.tws-offer', root).forEach(function (card) {
      var after = card.getAttribute('data-after');
      $$('[data-tws-eb]', card).forEach(function (f) { f.hidden = true; });
      if (after) { var p = $('[data-tws-offer-price]', card); if (p) p.textContent = after; }
    });
  }

  /* ---------- Engraving preview ---------- */
  function initEngrave(root) {
    if (root.__tws) return; root.__tws = true;
    var input = $('[data-tws-eng-text]', root), out = $('[data-tws-eng-out]', root), disc = $('[data-tws-eng-disc]', root);
    var link = $('[data-tws-eng-link]', root), price = $('[data-tws-eng-price]', root);
    function upd() {
      var c = $('input[name="tws-eng-board"]:checked', root);
      out.textContent = input.value.trim() || input.getAttribute('placeholder') || 'Your text here';
      if (c) { disc.style.background = c.getAttribute('data-color'); disc.style.color = c.getAttribute('data-ink'); if (link) link.href = c.getAttribute('data-url'); if (price) price.textContent = c.getAttribute('data-price'); }
    }
    root.addEventListener('input', upd); root.addEventListener('change', upd); upd();
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-tws-pdp]', scope).forEach(initPdp);
    $$('[data-tws-filter]', scope).forEach(initFilter);
    $$('[data-tws-forms]', scope).forEach(initForm);
    $$('[data-tws-estimator]', scope).forEach(initEstimator);
    $$('[data-tws-engrave]', scope).forEach(initEngrave);
    $$('[data-tws-countdown]', scope).forEach(initCountdown);
    $$('[data-tws-offers]', scope).forEach(initOffers);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
